import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const dsn = (
        (config.public.sentryDsn as string)
        || (config.public.glitchtipDsn as string)
        || ''
    ).trim();

    // GlitchTip / Sentry is optional: if no DSN is provided, do not initialize
    if (!dsn) {
        return;
    }

    const release = ((config.public.sentryRelease as string) || '').trim() || undefined;

    Sentry.init({
        app: nuxtApp.vueApp,
        dsn,
        release,
        environment: (config.public.appEnv as string) || 'production',
        tracesSampleRate: 0,
    });

    nuxtApp.hook('vue:error', (error, instance, info) => {
        Sentry.captureException(error, {
            extra: { info },
        });
    });

    nuxtApp.hook('app:error', (error) => {
        Sentry.captureException(error);
    });

    console.log('[glitchtip] Initialized client error tracking');
});
